module.exports = __webpack_public_path__ + "media/introduction_4.bb38b0f5.mp4";